module.exports = __webpack_public_path__ + "static/media/settings-close-icon.b52b16c5.svg";